import React from 'react'
import { Provider } from 'react-redux'

import { store } from './Store'
import AppFrame from './Components/AppFrame'

import { ConnectedThemeProvider } from './Themes/connected-theme-provider'
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { compose } from 'ramda';
import { withCookiesBanner } from 'CookiesPolicyBanner';
import '@scuf/common/honeywell-compact-combined/theme.css'
import '@scuf/datatable/honeywell-compact-combined/theme.css'
import './App.css'
import config from 'Config/AppConfig'
import { defaultFlags } from 'Utils/launch-darkly-flags'

function App () {
  return (
    <Provider store={store}>
      <ConnectedThemeProvider>
        <AppFrame />
      </ConnectedThemeProvider>
    </Provider>
  )
}

const withReduxStoreProvider = Component => props => {
  return (
    <Provider store={store}>
      <Component {...props} />
    </Provider>
  )
}
export default compose(
withReduxStoreProvider,
withCookiesBanner,
withLDProvider({
  clientSideID: config.launchDarkly.clientId,
  context: {
    kind: 'user',
    key: config.launchDarkly.clientType,
  },
  options: {
    bootstrap: defaultFlags,
  },
}))(App)
